module.exports = __webpack_public_path__ + "static/img/merveilleux.a7add0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/emotions/merveilleux.png
// module id = 6m3a
// module chunks = 0